import { render, staticRenderFns } from "./itemWiseReport.vue?vue&type=template&id=703724e3&scoped=true&"
import script from "./itemWiseReport.vue?vue&type=script&lang=js&"
export * from "./itemWiseReport.vue?vue&type=script&lang=js&"
import style0 from "./itemWiseReport.vue?vue&type=style&index=0&id=703724e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703724e3",
  null
  
)

export default component.exports